import { Observable } from "rxjs";

export abstract class ITranslationService {
  abstract onLanguageChange(language: string): void;
  abstract getLanguage(): Observable<any>;
  abstract getLanguagesList(): Observable<string>;
}
